import React from "react";

const IconViewer = ({ img }) => {
  let src = "/chat/default.svg";

  switch (img) {
    case "error":
      src = "/chat/error.gif";
      break;

    case "success":
      src = "/chat/success.gif";
      break;

    case "thinking":
      src = "/chat/thinking.gif";
      break;

    default:
      src = "/chat/default.svg";
  }

  return (
    <img
      className="h-12 w-12"
      src={src}
      alt={img || "default"}
    />
  );
};

export default IconViewer;
